
import {defineComponent} from 'vue';
import ChromeHero from "@/components/chrome/ChromeHero.vue";
import CommonNews from "@/components/common/CommonNews.vue";
import ChromeDeals from "@/components/chrome/ChromeDeals.vue";
import ChromeSavings from "@/components/chrome/ChromeSavings.vue";
import ChromePayments from "@/components/chrome/ChromePayments.vue";
import ChromeInsights from "@/components/chrome/ChromeInsights.vue";
import CommonTestimonials from "@/components/common/CommonTestimonials.vue";
import ChromeIntroduction from "@/components/chrome/ChromeIntroduction.vue";
import ChromeExtension from "@/components/chrome/ChromeExtension.vue";
import CommonStart from "@/components/common/CommonStart.vue";

export default defineComponent({
    name: 'Chrome',
    components: {
        ChromeHero,
        CommonNews,
        ChromeDeals,
        ChromeSavings,
        ChromePayments,
        ChromeInsights,
        CommonTestimonials,
        ChromeIntroduction,
        ChromeExtension,
        CommonStart
    },
});
